@if (playerDetailReady$ | async) {
  <app-screen-shell
    contentWidth="standard"
    [contentClass]="playerDetailShellClasses()"
    [contentInset]="shouldShowPlayerDetailHeader() ? 'none' : 'page'"
    [showHeader]="shouldShowPlayerDetailHeader()"
    [titleKey]="playerDetailHeaderTitleKey()"
    (back)="playerDetailHeaderBack()">
    @if (eventDetailMode || chatPlayerMode || profileSettingsMode === 'menu') {
    <section class="card profile-content-width player-detail-content-width player-detail-card" [class.profile-settings-menu-card]="!eventDetailMode && !chatPlayerMode && profileSettingsMode === 'menu'">
      <div class="player-detail-card-body">
        <div class="player-detail-summary">
          <div class="player-detail-card-actions">
            @if (!eventDetailMode && !chatPlayerMode) {
              <button type="button" class="player-detail-share-button" [disabled]="profileShareBusy" [title]="'players.shareProfile' | translate" [attr.aria-label]="'players.shareProfile' | translate" (click)="shareProfile()">
                <i [class]="'common.share' | nogoshIcon" aria-hidden="true"></i>
              </button>
            }
          </div>
          <div class="player-detail-heading">
            <button type="button" class="player-detail-avatar-shell player-team-avatar player-detail-shortcut"
              [class.is-enabled]="canUseProfileShortcuts() || !!player.avatar"
              [class.is-manager-avatar]="!isChatSettingsPlayerDetail() && isMatchManagerPlayer()"
              [class.is-manager-added-avatar]="!isChatSettingsPlayerDetail() && !isMatchManagerPlayer() && isGuestPlayer(player)"
              [class.is-first-team-avatar]="!isChatSettingsPlayerDetail() && !isMatchManagerPlayer() && !isGuestPlayer(player) && isMatchFirstTeamPlayer()"
              [class.is-reserve-avatar]="!isChatSettingsPlayerDetail() && !isMatchManagerPlayer() && !isGuestPlayer(player) && isMatchReservePlayer()"
              [disabled]="!canUseProfileShortcuts() && !player.avatar"
              [title]="eventDetailMode ? matchPlayerRoleLabel() : ('players.avatarTitle' | translate)"
              [attr.aria-label]="eventDetailMode ? matchPlayerRoleLabel() : ('players.avatarTitle' | translate)"
              (click)="openAvatar()">
              <img [src]="player.avatar ? player.avatar  : '../../assets/images/user1.jpg'"
                onerror="this.src='../../assets/images/user1.jpg'" class="player-detail-avatar rounded-circle border"
                [alt]="'accessibility.userProfileImage' | translate">
              @if (!isChatSettingsPlayerDetail() && eventDetailMode && isMatchManagerPlayer()) {
                <span class="player-team-status-icon player-team-status-letter" aria-hidden="true">M</span>
              }
              @if (!isChatSettingsPlayerDetail() && eventDetailMode && !isMatchManagerPlayer() && isGuestPlayer(player)) {
                <span class="player-team-status-icon" aria-hidden="true"><i [class]="'player.add' | nogoshIcon"></i></span>
              }
              @if (!isChatSettingsPlayerDetail() && eventDetailMode && !isMatchManagerPlayer() && !isGuestPlayer(player) && isMatchFirstTeamPlayer()) {
                <span class="player-team-status-icon" aria-hidden="true"><i [class]="'match.status.firstTeam' | nogoshIcon"></i></span>
              }
              @if (!isChatSettingsPlayerDetail() && eventDetailMode && !isMatchManagerPlayer() && !isGuestPlayer(player) && isMatchReservePlayer()) {
                <span class="player-team-status-icon player-team-status-letter" aria-hidden="true">R</span>
              }
            </button>
            <div class="player-detail-heading-copy">
              <button type="button" class="player-detail-title-shortcut player-detail-shortcut" [class.is-enabled]="canUseProfileShortcuts()" [disabled]="!canUseProfileShortcuts()" [title]="'common.name' | translate" [attr.aria-label]="'common.name' | translate" (click)="openProfileShortcut('profile')">
                <span class="player-detail-nickname mb-0 text-truncate">{{player.nickName}}</span>
              </button>
              @if (event.viewedByManager && player.name && player.name !== player.nickName) {
                <p class="player-detail-name mb-0 text-truncate">{{player.name}}</p>
              }
              <div class="player-detail-context">
                @if (!eventDetailMode && !chatPlayerMode && player.city) {
                  <button type="button" class="player-detail-context-shortcut player-detail-shortcut" [class.is-enabled]="canUseProfileShortcuts()" [disabled]="!canUseProfileShortcuts()" [title]="'common.location' | translate" [attr.aria-label]="'common.location' | translate" (click)="openProfileShortcut('location')">{{ displayCity() }}</button>
                }
                @if (joinedAt()) {
                  <span class="player-detail-meta-pill">
                    @if (!eventDetailMode && !chatPlayerMode && isCurrentPlayerProfile()) {
                      <i [class]="loginMethodIconClass()" [title]="loginMethodLabel()" [attr.aria-label]="loginMethodLabel()"></i>
                    }
                    {{ 'players.joined' | translate }} {{ joinedAt() | date:'MMM yyyy':undefined:(selectedLanguage === 'hr' ? 'hr' : 'en') }}
                  </span>
                }
                @if (!eventDetailMode && isGuestPlayer(player)) {
                  <span class="badge badge-status text-white">{{ accountlessPlayerLabel(player) }}</span>
                }
              </div>
            </div>
          </div>
          <div class="player-detail-stats-layout">
            <div class="player-detail-rating-column">
              @if (!isHistoryEventDetail() && (eventDetailMode || (!eventDetailMode && isCurrentPlayerProfile()))) {
                <div class="player-detail-metric is-rating" [title]="'players.offence' | translate">
                  <span class="player-detail-metric-label">{{ 'players.offence' | translate }}</span>
                  <strong><i [class]="'player.rating' | nogoshIcon" aria-hidden="true"></i>{{ ratingAverageOffence || '–' }}</strong>
                </div>
                <div class="player-detail-metric is-rating" [title]="'players.defence' | translate">
                  <span class="player-detail-metric-label">{{ 'players.defence' | translate }}</span>
                  <strong><i [class]="'player.rating' | nogoshIcon" aria-hidden="true"></i>{{ ratingAverageDefence || '–' }}</strong>
                </div>
              }
            </div>
            <div class="player-detail-performance-column">
              <div class="player-detail-metric player-detail-record-metric is-primary">
                <div class="player-detail-record-value">
                  <div class="player-detail-played-count">
                    <span>{{ 'stats.played' | translate }}</span>
                    <strong>{{ profileStatValue(profileStatsSummary?.playedGames) }}</strong>
                  </div>
                  <div class="player-detail-record-breakdown">
                    <span><strong>{{ profileStatValue(profileStatsSummary?.playerWins) }}</strong>W</span>
                    <span><strong>{{ profileStatValue(profileStatsSummary?.playerDraws) }}</strong>D</span>
                    <span><strong>{{ profileStatValue(profileStatsSummary?.playerLoses) }}</strong>L</span>
                  </div>
                </div>
              </div>
              <div class="player-detail-metric player-detail-goal-metric" [title]="'players.teamGoalDeltaHint' | translate">
                <div class="player-detail-goal-value">
                  <div class="player-detail-goal-delta">
                    <span>{{ 'players.goals' | translate }} Δ</span>
                    <strong>{{ teamGoalScore() }}</strong>
                  </div>
                  <div class="player-detail-goal-breakdown">
                    <span [title]="'players.goalsForHint' | translate"><strong>{{ profileStatValue(profileStatsSummary?.playerScored) }}</strong>GF</span>
                    <span [title]="'players.goalsAgainstHint' | translate"><strong>{{ profileStatValue(profileStatsSummary?.playerConceded) }}</strong>GA</span>
                  </div>
                </div>
              </div>
              <div class="player-detail-metric player-detail-teams-metric">
                <span class="player-detail-metric-label">{{ 'players.teamsCount' | translate }}</span>
                <strong>{{ profileStatValue(profileStatsSummary?.teamsCount) }}</strong>
              </div>
            </div>
          </div>
          <div class="player-detail-actions">
            <div class="player-detail-actions-group">
              @if (canShowFootballerFriendsAction()) {
                <button type="button" class="player-detail-contact-action" (click)="openFootballerFriends()" [title]="'players.footballerFriends' | translate" [attr.aria-label]="'players.footballerFriends' | translate">
                  <i [class]="'player.team' | nogoshIcon" aria-hidden="true"></i>
                  <span class="sr-only">{{ 'players.footballerFriends' | translate }}</span>
                </button>
              }
              @if (canShowMatchHistoryAction()) {
                <button type="button" class="player-detail-contact-action" (click)="openMatchHistory()" [title]="'players.matchHistory' | translate" [attr.aria-label]="'players.matchHistory' | translate">
                  <i [class]="'match.history' | nogoshIcon" aria-hidden="true"></i>
                  <span class="sr-only">{{ 'players.matchHistory' | translate }}</span>
                </button>
              }
              @if (canShowFootballReferencesAction()) {
                <button type="button" class="player-detail-contact-action" (click)="openFootballReferences()" [title]="'players.footballReferences' | translate" [attr.aria-label]="'players.footballReferences' | translate">
                  <i [class]="'match.inviteFriends' | nogoshIcon" aria-hidden="true"></i>
                  <span class="sr-only">{{ 'players.footballReferences' | translate }}</span>
                </button>
              }
            </div>
            @if (canShowPlayerContactActions()) {
              <div class="player-detail-actions-group player-detail-contact-actions-bottom">
                @if (player.phoneNumber) {
                  <a class="player-detail-contact-action" [href]="'tel:' + player.phoneNumber" [title]="'players.call' | translate" [attr.aria-label]="'players.call' | translate">
                    <i [class]="'player.phone' | nogoshIcon" aria-hidden="true"></i>
                    <span class="sr-only">{{ 'players.call' | translate }}</span>
                  </a>
                }
                <button type="button" class="player-detail-contact-action is-primary" (click)="enterOrCreateNewChat(player)" [title]="'players.chat' | translate" [attr.aria-label]="'players.chat' | translate">
                  <i [class]="'chat.chat' | nogoshIcon" aria-hidden="true"></i>
                  <span class="sr-only">{{ 'players.chat' | translate }}</span>
                </button>
                @if (player.loginEmail || player.email) {
                  <a class="player-detail-contact-action" [href]="'mailto:' + (player.loginEmail || player.email)" [title]="'common.email' | translate" [attr.aria-label]="'common.email' | translate">
                    <i [class]="'player.email' | nogoshIcon" aria-hidden="true"></i>
                    <span class="sr-only">{{ 'common.email' | translate }}</span>
                  </a>
                }
              </div>
            }
          </div>
        </div>

        @if (canRatePlayer() && !eventDetailMode) {
        <div class="player-detail-rating-grid" [ngClass]="{'single-column': isCurrentPlayerProfile()}">
            <section class="player-rating-panel">
              <div class="player-rating-panel-header">
                <b>{{ 'players.ratePlayer' | translate }}</b>
              </div>
              <div class="player-rating-row">
                <div class="player-rating-label">
                  <span>{{ 'players.defence' | translate }}</span>
                  @if (ratingDefence) {
                    <button
                      type="button"
                      class="btn btn-link btn-sm profile-rating-clear"
                      (click)="clearDefence()">
                      {{ 'players.clearRating' | translate }}
                    </button>
                  }
                </div>
                <div class="profile-rating-control" role="radiogroup" [attr.aria-label]="'players.defence' | translate">
                  @for (value of ratingScale; track value) {
                    <button
                      type="button"
                      class="btn btn-sm btn-{{value <= ratingDefence ? 'primary' : 'default'}}"
                      role="radio"
                      [attr.aria-checked]="value === ratingDefence"
                      (click)="setDefence(value)">
                      {{value <= ratingDefence ? '&#9733;' : '&#9734;'}}
                    </button>
                  }
                </div>
              </div>
              <div class="player-rating-row">
                <div class="player-rating-label">
                  <span>{{ 'players.offence' | translate }}</span>
                  @if (ratingOffence) {
                    <button
                      type="button"
                      class="btn btn-link btn-sm profile-rating-clear"
                      (click)="clearOffence()">
                      {{ 'players.clearRating' | translate }}
                    </button>
                  }
                </div>
                <div class="profile-rating-control" role="radiogroup" [attr.aria-label]="'players.offence' | translate">
                  @for (value of ratingScale; track value) {
                    <button
                      type="button"
                      class="btn btn-sm btn-{{value <= ratingOffence ? 'primary' : 'default'}}"
                      role="radio"
                      [attr.aria-checked]="value === ratingOffence"
                      (click)="setOffence(value)">
                      {{value <= ratingOffence ? '&#9733;' : '&#9734;'}}
                    </button>
                  }
                </div>
              </div>
            </section>
          <section class="player-rating-panel">
            <div class="player-rating-panel-header">
              <b>{{ 'players.totalRating' | translate }}</b>
            </div>
            <div class="player-rating-row">
              <div class="player-rating-label">
                <span>{{ 'players.defence' | translate }}</span>
              </div>
              <div class="profile-rating-control profile-rating-readonly" [attr.aria-label]="'players.defence' | translate">
                @for (value of ratingScale; track value) {
                  <button
                    type="button"
                    class="btn btn-sm btn-{{value <= ratingAverageDefence ? 'primary' : 'default'}}"
                    disabled>
                    {{value <= ratingAverageDefence ? '&#9733;' : '&#9734;'}}
                  </button>
                }
              </div>
            </div>
            <div class="player-rating-row">
              <div class="player-rating-label">
                <span>{{ 'players.offence' | translate }}</span>
              </div>
              <div class="profile-rating-control profile-rating-readonly" [attr.aria-label]="'players.offence' | translate">
                @for (value of ratingScale; track value) {
                  <button
                    type="button"
                    class="btn btn-sm btn-{{value <= ratingAverageOffence ? 'primary' : 'default'}}"
                    disabled>
                    {{value <= ratingAverageOffence ? '&#9733;' : '&#9734;'}}
                  </button>
                }
              </div>
            </div>
          </section>
        </div>
        }
      </div>
    </section>
    }
    @if (eventDetailMode) {
      <div class="profile-content-width player-detail-content-width player-match-dashboard">
    <!-- MANAGER EDITS section -->
    @if (!isChatSettingsPlayerDetail() && eventDetailMode && event.viewedByManager && !chatPlayerMode && (playerEventInfo.teamMemberType != teamMemberType.CANDIDATE)) {
      <div class="profile-content-width player-detail-content-width player-match-management">
        <div class="card player-info-card">
          <div class="card-body py-3 px-3">
            <section class="player-info-control player-attendance-control" [ngClass]="{'border-bottom border-bottom-not-last pb-3': !isHistoryEventDetail()}">
              <div class="player-info-heading">
                <div>
                  <h6 class="mb-0">{{ 'players.attendance' | translate }}</h6>
                  <p class="text-nogosh-grey3 text-sm mb-0">{{ displayAttendanceStatus(playerEventInfo.status) }}</p>
                </div>
              </div>
              <div class="player-info-button-row player-attendance-icon-row" [attr.aria-label]="'players.attendance' | translate">
                <button (click)="playerEventInfo.status !== playerEventInfoStatus.CONFIRMED ? mngUpdateInviteStatus(event, playerEventInfoStatus.CONFIRMED) : false"
                  class="player-match-icon-button is-confirmed" [title]="'events.confirmed' | translate" [attr.aria-label]="'events.confirmed' | translate"
                  [class.active]="playerEventInfo.status === playerEventInfoStatus.CONFIRMED">
                  <i [class]="'common.selected' | nogoshIcon" aria-hidden="true"></i>
                </button>
                <button (click)="playerEventInfo.status !== playerEventInfoStatus.NOT_ANSWERED ? mngUpdateInviteStatus(event, playerEventInfoStatus.NOT_ANSWERED) : false"
                  class="player-match-icon-button is-not-answered" [title]="'events.notAnswered' | translate" [attr.aria-label]="'events.notAnswered' | translate"
                  [class.active]="playerEventInfo.status === playerEventInfoStatus.NOT_ANSWERED">
                  <i [class]="'common.question' | nogoshIcon" aria-hidden="true"></i>
                </button>
                <button (click)="playerEventInfo.status !== playerEventInfoStatus.DECLINED ? mngUpdateInviteStatus(event, playerEventInfoStatus.DECLINED): false"
                  class="player-match-icon-button is-declined" [title]="'stats.declined' | translate" [attr.aria-label]="'stats.declined' | translate"
                  [class.active]="playerEventInfo.status === playerEventInfoStatus.DECLINED">
                  <i [class]="'match.status.declined' | nogoshIcon" aria-hidden="true"></i>
                </button>
                <button (click)="playerEventInfo.status !== playerEventInfoStatus.NOT_NOTIFIED ? mngUpdateInviteStatus(event, playerEventInfoStatus.NOT_NOTIFIED) : false"
                  class="player-match-icon-button is-not-notified" [title]="'events.notNotified' | translate" [attr.aria-label]="'events.notNotified' | translate"
                  [class.active]="playerEventInfo.status === playerEventInfoStatus.NOT_NOTIFIED">
                  <i [class]="'common.minus' | nogoshIcon" aria-hidden="true"></i>
                </button>
              </div>
              @if (!isHistoryEventDetail() && !isGuestPlayer(player) && playerEventInfo.teamMemberType !== teamMemberType.CANDIDATE && playerEventInfo.status === playerEventInfoStatus.NOT_NOTIFIED && !playerEventInfo.invitationSentAt) {
                <div class="player-attendance-invite-row">
                  <button type="button" (click)="invitePlayer()" class="btn btn-sm px-3 btn-primary">
                    {{ 'players.invite' | translate }}
                  </button>
                </div>
              }
              @if (!isHistoryEventDetail() && !isGuestPlayer(player) && playerEventInfo.teamMemberType !== teamMemberType.CANDIDATE && playerEventInfo.status === playerEventInfoStatus.NOT_ANSWERED && !playerEventInfo.reminderSentAt) {
                <div class="player-attendance-invite-row">
                  <button type="button" (click)="notifyPlayer()" class="btn btn-sm px-3 btn-primary">
                    {{ 'players.remind' | translate }}
                  </button>
                </div>
              }
              @if (!isHistoryEventDetail() && !isGuestPlayer(player) && playerEventInfo.teamMemberType !== teamMemberType.CANDIDATE && playerEventInfo.status === playerEventInfoStatus.NOT_ANSWERED && playerEventInfo.reminderSentAt) {
                <p class="text-nogosh-grey3 mb-0 text-center">{{ 'notifications.playerInvitationLimitReached' | translate }}</p>
              }
            </section>
            @if (!isHistoryEventDetail()) {
            <section class="player-info-control player-team-control pt-3">
              <div class="player-info-heading">
                <div>
                  <h6 class="mb-0">{{ 'players.team' | translate }}</h6>
                  <p class="text-capitalize text-nogosh-grey3 text-sm mb-0" >
                    @if (playerEventInfo.teamMemberType === teamMemberType.FIRST_TEAM) {
                      <span >{{ 'notifications.firstTeam' | translate }}</span>
                    }
                    @if (playerEventInfo.teamMemberType === teamMemberType.RESERVE) {
                      <span>{{ 'players.reserve' | translate }}</span>
                    }
                  </p>
                </div>
              </div>
              <div class="player-info-button-row player-team-button-row" [attr.aria-label]="'players.team' | translate">
                <button (click)="playerEventInfo.teamMemberType !== teamMemberType.FIRST_TEAM ? changePlayerTeam(playerEventInfo, teamMemberType.FIRST_TEAM) : false"
                  [class.active]="playerEventInfo.teamMemberType === teamMemberType.FIRST_TEAM"
                  class="player-team-role-button is-first-team"
                  [title]="'notifications.firstTeam' | translate"
                  [attr.aria-label]="'notifications.firstTeam' | translate">
                  <span class="player-team-role-icon"><i [class]="'match.status.firstTeam' | nogoshIcon" aria-hidden="true"></i></span>
                  <span class="sr-only">{{ 'notifications.firstTeam' | translate }}</span>
                </button>
                <button (click)="playerEventInfo.teamMemberType !== teamMemberType.RESERVE ? changePlayerTeam(playerEventInfo, teamMemberType.RESERVE): false"
                  [class.active]="playerEventInfo.teamMemberType === teamMemberType.RESERVE"
                  class="player-team-role-button is-reserve"
                  [title]="'players.reserve' | translate"
                  [attr.aria-label]="'players.reserve' | translate">
                  <span class="player-team-role-icon player-team-status-letter">R</span>
                  <span class="sr-only">{{ 'players.reserve' | translate }}</span>
                </button>
              </div>
            </section>
            }
          </div>
        </div>
      </div>
    }
    <!-- end of MANAGER EDITS section -->
    @if (canRatePlayer() && eventDetailMode) {
      <section class="profile-content-width player-detail-content-width player-match-rating" [attr.aria-label]="'players.ratePlayer' | translate">
        <div class="card">
          <div class="card-body py-3 px-3">
            <div class="player-rating-panel-header">
              <span class="player-rating-panel-icon"><i [class]="'player.rating' | nogoshIcon" aria-hidden="true"></i></span>
              <b>{{ 'players.ratePlayer' | translate }} {{ player.nickName }}</b>
            </div>
            <div class="player-rating-row">
              <div class="player-rating-label">
                <span>{{ 'players.offence' | translate }}</span>
                <strong>{{ displaySliderRating(ratingOffenceSliderValue) || '–' }}</strong>
              </div>
              <div class="profile-rating-control player-rating-slider-control" [style.--rating-percent.%]="ratingSliderPercent(ratingOffenceSliderValue)">
                <input type="range" min="0" max="10" step="0.01" [value]="ratingOffenceSliderValue || 0" (input)="ratingOffenceSliderValue = $any($event.target).valueAsNumber" (change)="setOffenceFromSlider($any($event.target).valueAsNumber)" [attr.aria-label]="'players.offence' | translate">
                <div class="player-rating-slider-scale" aria-hidden="true">
                  <span>0</span>
                  <span>10</span>
                </div>
                @if (ratingOffence) {
                  <button type="button" class="player-rating-clear-button" (click)="clearOffence()">{{ 'common.clear' | translate }}</button>
                }
              </div>
            </div>
            <div class="player-rating-row">
              <div class="player-rating-label">
                <span>{{ 'players.defence' | translate }}</span>
                <strong>{{ displaySliderRating(ratingDefenceSliderValue) || '–' }}</strong>
              </div>
              <div class="profile-rating-control player-rating-slider-control" [style.--rating-percent.%]="ratingSliderPercent(ratingDefenceSliderValue)">
                <input type="range" min="0" max="10" step="0.01" [value]="ratingDefenceSliderValue || 0" (input)="ratingDefenceSliderValue = $any($event.target).valueAsNumber" (change)="setDefenceFromSlider($any($event.target).valueAsNumber)" [attr.aria-label]="'players.defence' | translate">
                <div class="player-rating-slider-scale" aria-hidden="true">
                  <span>0</span>
                  <span>10</span>
                </div>
                @if (ratingDefence) {
                  <button type="button" class="player-rating-clear-button" (click)="clearDefence()">{{ 'common.clear' | translate }}</button>
                }
              </div>
            </div>
          </div>
        </div>
      </section>
    }
    @if (canManageGuestClaimInvitation()) {
      <div class="profile-content-width player-detail-content-width player-guest-claim">
        <div class="card">
          <div class="card-body py-3 px-3">
            <div class="player-guest-claim-heading">
              <b><i [class]="'player.claim' | nogoshIcon" aria-hidden="true"></i>{{ 'guestClaim.claimProfile' | translate }}</b>
              <span class="text-nogosh-grey3 text-sm">{{ 'players.guestClaimHint' | translate }}</span>
            </div>
            <p class="player-guest-claim-description text-nogosh-grey3 text-sm">
              {{ 'players.guestClaimDescription' | translate }}
            </p>
            @if (claimInvitationMessage) {
              <div class="alert alert-success py-2">{{claimInvitationMessage}}</div>
            }
            @if (claimInvitationError) {
              <div class="alert alert-danger py-2">{{claimInvitationError}}</div>
            }
            <div class="form-group player-guest-claim-form">
              <label for="claimInvitationEmail" class="mb-0">{{ 'players.guestClaimEmail' | translate }}</label>
              <input [(ngModel)]="claimInvitationEmail" type="email" class="form-control" id="claimInvitationEmail" name="claimInvitationEmail" placeholder="player@example.com" autocomplete="off">
              <button type="button" class="btn btn-primary btn-sm px-3" [disabled]="claimInvitationLoading" (click)="sendGuestClaimInvitation()">{{ 'players.guestClaimSend' | translate }}</button>
            </div>
            @if (claimInvitation) {
              <div class="players-list border-top mt-3 pt-3">
                <h6 class="mb-2">{{ 'players.guestClaimLastInvitation' | translate }}</h6>
                <p class="text-nogosh-grey3 text-sm mb-1">{{ 'common.status' | translate }}: {{claimInvitation.status}}</p>
                <p class="text-nogosh-grey3 text-sm mb-1">{{ 'common.email' | translate }}: {{claimInvitation.email}}</p>
                <p class="text-nogosh-grey3 text-sm mb-2">{{ 'players.guestClaimExpiresAt' | translate }}: {{claimInvitation.expiresAt}}</p>
                @if (claimInvitation.status === 'PENDING') {
                  <div class="d-flex flex-wrap">
                    <button type="button" class="btn btn-outline-primary btn-sm px-3 mr-2 mb-2" [disabled]="claimInvitationLoading" (click)="resendGuestClaimInvitation()">{{ 'players.guestClaimResend' | translate }}</button>
                    <button type="button" class="btn btn-outline-danger btn-sm px-3 mb-2" [disabled]="claimInvitationLoading" (click)="revokeGuestClaimInvitation()">{{ 'players.guestClaimRevoke' | translate }}</button>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    }
    @if (!isChatSettingsPlayerDetail() && !isHistoryEventDetail() && eventDetailMode && event.viewedByManager && !chatPlayerMode && playerEventInfo && playerEventInfo.teamMemberType != teamMemberType.CANDIDATE && event.manager && event.manager.id != playerEventInfo.player.id) {
      <div class="profile-content-width player-detail-content-width player-match-danger-actions" [class.has-single-action]="isGuestPlayer(player)">
        @if (!isGuestPlayer(player)) {
          <button type="button" class="btn btn-outline-primary btn-sm px-3" (click)="requestSetAsManager()">{{ 'players.setManagerConfirmTitle' | translate }}</button>
        }
        <button type="button" class="btn btn-outline-danger btn-sm px-3" [disabled]="removeFromMatchInProgress" (click)="requestRemovePlayerFromMatch()">
          @if (removeFromMatchInProgress) {
            <app-delayed-indicator></app-delayed-indicator>
          }
          {{ 'events.removeFromMatch' | translate }}
        </button>
        <app-dialog [(visible)]="showSetManagerConfirmDialog" [closable]="false" class="app-dialog--confirm">
          <div class="modal-header">
            <h5 class="mb-0">{{ 'players.setManagerConfirmTitle' | translate }}</h5>
          </div>
          <div class="modal-body">
            <p class="mb-0">{{ 'players.setManagerConfirmMessage' | translate:{ name: player.nickName || player.name } }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-sm px-3" (click)="showSetManagerConfirmDialog = false">{{ 'common.cancel' | translate }}</button>
            <button type="button" class="btn btn-primary text-white btn-sm px-3" (click)="confirmSetAsManager()">{{ 'players.setManagerConfirmTitle' | translate }}</button>
          </div>
        </app-dialog>
        <app-dialog [(visible)]="showRemoveFromMatchConfirmDialog" [closable]="false" class="app-dialog--confirm">
          <div class="modal-header">
            <h5 class="mb-0">{{ 'events.removeFromMatch' | translate }}</h5>
          </div>
          <div class="modal-body">
            <p class="mb-0">{{ 'players.removeFromMatchConfirmMessage' | translate:{ name: player.nickName || player.name } }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-sm px-3" [disabled]="removeFromMatchInProgress" (click)="showRemoveFromMatchConfirmDialog = false">{{ 'common.cancel' | translate }}</button>
            <button type="button" class="btn btn-danger btn-sm px-3" [disabled]="removeFromMatchInProgress" (click)="confirmRemovePlayerFromMatch()">
              @if (removeFromMatchInProgress) {
                <app-delayed-indicator></app-delayed-indicator>
              }
              {{ 'events.removeFromMatch' | translate }}
            </button>
          </div>
        </app-dialog>
      </div>
    }
    @if (canRemovePlayerFromChat()) {
      <div class="profile-content-width player-detail-content-width player-match-danger-actions has-single-action">
        <button type="button" class="btn btn-outline-danger btn-sm px-3" [disabled]="removeFromChatInProgress" (click)="openRemoveFromChatDialog()">
          @if (removeFromChatInProgress) {
            <app-delayed-indicator></app-delayed-indicator>
          }
          {{ 'players.removeFromChat' | translate }}
        </button>
        <app-dialog [(visible)]="showRemoveFromChatDialog" [closable]="false" class="app-dialog--confirm">
          <div class="modal-header">
            <h5 class="mb-0">{{ 'players.removeFromChat' | translate }}</h5>
          </div>
          <div class="modal-body">
            <p class="mb-0">{{ 'players.removeFromChatConfirmMessage' | translate:{ name: player.nickName || player.name } }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-sm px-3" [disabled]="removeFromChatInProgress" (click)="showRemoveFromChatDialog = false">{{ 'common.cancel' | translate }}</button>
            <button type="button" class="btn btn-danger btn-sm px-3" [disabled]="removeFromChatInProgress" (click)="removePlayerFromChat()">
              @if (removeFromChatInProgress) {
                <app-delayed-indicator></app-delayed-indicator>
              }
              {{ 'players.removeFromChat' | translate }}
            </button>
          </div>
        </app-dialog>
      </div>
    }
      </div>
    }
    <!-- PLAYER CONTACT section -->
    @if (!eventDetailMode && event.viewedByManager && !chatPlayerMode && !isGuestPlayer(player)) {
      <div class="row team-all mt-4 my-0 px-3 align-items-center profile-content-width player-detail-content-width">
        <div class="col-auto my-0 mb-1">
          <b class="text-left fr-header">{{ 'players.contact' | translate }}</b>
        </div>
      </div>
    }
    @if (event.viewedByManager && !eventDetailMode && !isCurrentPlayerProfile() && !chatPlayerMode && !isGuestPlayer(player)) {
      <div class="players-list-wrapper card profile-content-width player-detail-content-width">
        <div class="card-body px-3 py-1">
          <div class="players-list border-bottom border-bottom-not-last py-2">
            <a [href]="'tel: ' + player.phoneNumber">
              <p class="h6 pb-0 mb-0">{{ 'common.phoneNumber' | translate }}</p>
            </a>
            <a [href]="'tel: ' + player.phoneNumber">
              <label for="email" class="mb-0">{{player.phoneNumber}}</label>
            </a>
          </div>
          <div class="players-list border-bottom border-bottom-not-last py-2">
            <a [href]="'mailto: ' + player.loginEmail">
              <p class="h6 pb-0 mb-0">{{ 'common.email' | translate }}</p>
            </a>
            <a [href]="'mailto: ' + player.loginEmail">
              <label for="email" class="mb-0">{{player.loginEmail}}</label>
            </a>
          </div>
        </div>
      </div>
    }
    <!-- end of PLAYER CONTACT section -->
    @if (errorMsg) {
      <div class="profile-content-width player-detail-content-width text-left text-danger">
        <p class="h6">{{ 'common.error' | translate }}: </p>
        <p class="h5">{{errorMsg}}</p>
      </div>
    }
    @if (!eventDetailMode && !chatPlayerMode) {
      <form (ngSubmit)="onSubmit()" autocomplete="off" #playerForm="ngForm" class="profile-content-width" [class.profile-settings-menu-form]="profileSettingsMode === 'menu'">
        <section class="profile-settings-screen"
          [class.is-screen-entering]="profileSettingsScreenEntering"
          [class.is-screen-exiting]="profileSettingsScreenExiting">
          @if (profileSettingsMode === 'menu') {
            <div>
              @if (shouldShowEmailVerificationReminder()) {
                <section class="alert alert-warning" role="status">
                  <p>{{ 'notifications.emailVerificationDescription' | translate }}</p>
                  <button type="button" class="btn btn-primary" (click)="openProfileSettingsMode('contact')">{{ 'notifications.emailVerificationTitle' | translate }}</button>
                </section>
              }
              <div class="profile-settings-options subscreen-menu-options">
                <button type="button" class="profile-settings-option subscreen-menu-option" (click)="openProfileSettingsMode('language')">
                  <i [class]="'common.text' | nogoshIcon" aria-hidden="true"></i><span>{{ 'settings.language.label' | translate }}</span>
                </button>
                <button type="button" class="profile-settings-option subscreen-menu-option" (click)="openLearn()">
                  <i [class]="'match.rulebook' | nogoshIcon" aria-hidden="true"></i><span>{{ 'learn.title' | translate }}</span>
                </button>
                <button type="button" class="profile-settings-option subscreen-menu-option" (click)="openProfileSettingsMode('profile')">
                  <i [class]="'player.profile' | nogoshIcon" aria-hidden="true"></i>
                  <span class="profile-settings-option-copy">
                    <span>{{ 'common.name' | translate }}</span>
                    <small>{{ 'players.profileMenuProfileDescription' | translate }}</small>
                  </span>
                </button>
                <button type="button" class="profile-settings-option subscreen-menu-option" (click)="openProfileSettingsMode('avatar')">
                  <i [class]="'player.camera' | nogoshIcon" aria-hidden="true"></i>
                  <span class="profile-settings-option-copy">
                    <span>{{ 'players.avatarTitle' | translate }}</span>
                    <small>{{ 'players.profileMenuAvatarDescription' | translate }}</small>
                  </span>
                </button>
                <button type="button" class="profile-settings-option subscreen-menu-option" (click)="openProfileSettingsMode('contact')">
                  <i [class]="'player.addressCard' | nogoshIcon" aria-hidden="true"></i>
                  <span class="profile-settings-option-copy">
                    <span>{{ 'common.contact' | translate }}</span>
                    <small>{{ 'players.profileMenuContactDescription' | translate }}</small>
                  </span>
                </button>
                <button type="button" class="profile-settings-option subscreen-menu-option" (click)="openProfileSettingsMode('location')">
                  <i [class]="'locations.location' | nogoshIcon" aria-hidden="true"></i>
                  <span class="profile-settings-option-copy">
                    <span>{{ 'common.location' | translate }}</span>
                    <small>{{ 'players.profileMenuLocationDescription' | translate }}</small>
                  </span>
                </button>
                <button type="button" class="profile-settings-option subscreen-menu-option" (click)="openProfileSettingsMode('notifications')">
                  <i [class]="'player.notifications' | nogoshIcon" aria-hidden="true"></i>
                  <span class="profile-settings-option-copy">
                    <span>{{ 'common.status' | translate }}</span>
                    <small>{{ 'players.profileMenuNotificationsDescription' | translate }}</small>
                  </span>
                </button>
                <button type="button" class="profile-settings-option subscreen-menu-option" (click)="openProfileSettingsMode('account')">
                  <i [class]="'player.security' | nogoshIcon" aria-hidden="true"></i>
                  <span class="profile-settings-option-copy">
                    <span>{{ 'players.profileMenuAccount' | translate }}</span>
                    <small>{{ 'players.profileMenuAccountDescription' | translate }}</small>
                  </span>
                </button>
                <button type="button" class="profile-settings-option subscreen-menu-option" (click)="openProfileSettingsMode('safety')">
                  <i [class]="'player.security' | nogoshIcon" aria-hidden="true"></i>
                  <span class="profile-settings-option-copy">
                    <span>{{ 'safety.title' | translate }}</span>
                    <small>{{ 'safety.blockedUsers' | translate }}</small>
                  </span>
                </button>
              </div>
            </div>
          }
          @if (profileSettingsMode === 'safety') {
            <div class="profile-settings-panel">
              <div class="card">
                <div class="card-body px-3 py-3">
                  <h3>{{ 'safety.blockedUsers' | translate }}</h3>
                  @if (!blockedPlayersLoading && blockedPlayers.length === 0) {
                    <p>{{ 'safety.noBlockedUsers' | translate }}</p>
                  }
                  @for (blockedPlayer of blockedPlayers; track blockedPlayer.playerId) {
                    <div class="d-flex align-items-center justify-content-between py-2 border-bottom">
                      <span>{{ blockedPlayer.nickName || blockedPlayer.name }}</span>
                      <button type="button" class="btn btn-outline-secondary" [disabled]="blockedPlayersLoading" (click)="unblockPlayer(blockedPlayer.playerId)">
                        {{ 'safety.unblock' | translate }}
                      </button>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
          @if (profileSettingsMode === 'avatar') {
            <div class="profile-settings-panel">
              <div class="card">
                <div class="card-body px-3 py-3">
                  <div class="profile-avatar-settings">
                    <img [src]="player.avatar ? player.avatar  : '../../assets/images/user1.jpg'"
                      onerror="this.src='../../assets/images/user1.jpg'"
                      class="profile-avatar-settings-preview rounded-circle border"
                      [alt]="'accessibility.userProfileImage' | translate">
                    <div class="profile-avatar-settings-copy">
                      <p class="mb-1 font-weight-bold">{{ 'players.avatarTitle' | translate }}</p>
                      <p class="mb-0 text-nogosh-grey3 text-sm">{{ 'players.avatarDescription' | translate }}</p>
                    </div>
                  </div>
                  <input #avatarLibraryInput type="file" accept="image/*" class="sr-only" (change)="avatarFileSelected($event)">
                  @if (avatarCameraActive) {
                    <div class="profile-avatar-camera mt-3">
                      <video #avatarCameraVideo class="profile-avatar-camera-video" playsinline muted (playing)="avatarVideoPlaying()" (error)="failAvatarCamera()"></video>
                      <canvas #avatarCameraCanvas class="sr-only"></canvas>
                      <div class="profile-avatar-camera-actions">
                        <button type="button" class="btn btn-outline-secondary btn-sm px-3" [disabled]="avatarUploading" (click)="stopAvatarCamera()">
                          {{ 'players.avatarCloseCamera' | translate }}
                        </button>
                        <button type="button" class="btn btn-primary btn-sm px-3" [disabled]="avatarUploading || !avatarCameraReady" (click)="captureAvatarPhoto()">
                          @if (avatarUploading) {
                            <app-delayed-indicator></app-delayed-indicator>
                          }
                          <i [class]="('common.check' | nogoshIcon) + ' mr-2'" aria-hidden="true"></i>{{ 'players.avatarUsePhoto' | translate }}
                        </button>
                      </div>
                    </div>
                  }
                  @if (avatarCropActive) {
                    <div class="profile-avatar-crop mt-3">
                      <canvas
                        #avatarCropCanvas
                        class="profile-avatar-crop-canvas"
                        width="512"
                        height="512"
                        (pointerdown)="avatarCropPointerDown($event)"
                        (pointermove)="avatarCropPointerMove($event)"
                        (pointerup)="avatarCropPointerUp($event)"
                        (pointercancel)="avatarCropPointerUp($event)"
                        (pointerleave)="avatarCropPointerUp($event)">
                      </canvas>
                      <label class="profile-avatar-crop-zoom mb-0">
                        <span>{{ 'players.avatarZoom' | translate }}</span>
                        <input
                          type="range"
                          min="1"
                          max="3"
                          step="0.05"
                          [value]="avatarCropZoom"
                          [disabled]="avatarUploading"
                          (input)="avatarCropZoomChanged($any($event.target).value)">
                      </label>
                      <div class="profile-avatar-camera-actions">
<button type="button" class="btn btn-outline-secondary btn-sm px-3" [disabled]="avatarUploading" (click)="cancelAvatarCrop()">
                          {{ 'common.cancel' | translate }}
                        </button>
                        <button type="button" class="btn btn-primary btn-sm px-3" [disabled]="avatarUploading" (click)="saveAvatarCrop()">
                          @if (avatarUploading) {
                            <app-delayed-indicator></app-delayed-indicator>
                          }
                          <i [class]="('common.save' | nogoshIcon) + ' mr-2'" aria-hidden="true"></i>{{ 'players.avatarSaveCrop' | translate }}
                        </button>

                      </div>
                    </div>
                  }
                  @if (avatarSuccess) {
                    <div class="alert alert-success py-2 mt-3 mb-0" role="status">{{ avatarSuccess }}</div>
                  }
                  @if (avatarError) {
                    <div class="alert alert-danger py-2 mt-3 mb-0" role="alert">{{ avatarError }}</div>
                  }
                </div>
              </div>
              <div class="profile-avatar-actions">
                <button type="button" class="btn btn-secondary btn-sm px-3" [disabled]="avatarUploading" (click)="closeProfileSettingsScreen()">{{ 'common.cancel' | translate }}</button>
                <button type="button" class="btn btn-primary btn-sm px-3" [disabled]="avatarUploading || avatarCameraStarting" (click)="openAvatarCamera()">
                  @if (avatarCameraStarting) {
                    <app-delayed-indicator></app-delayed-indicator>
                  }
                  <i [class]="('player.camera' | nogoshIcon) + ' mr-2'" aria-hidden="true"></i>{{ 'players.avatarTakePhoto' | translate }}
                </button>
                <button type="button" class="btn btn-outline-primary btn-sm px-3" [disabled]="avatarUploading" (click)="openAvatarLibrary()">
                  <i [class]="('player.image' | nogoshIcon) + ' mr-2'" aria-hidden="true"></i>{{ 'players.avatarChoosePhoto' | translate }}
                </button>
                @if (player.avatarSource === 'CUSTOM') {
                  <button type="button" class="btn btn-outline-danger btn-sm px-3" [disabled]="avatarUploading" (click)="resetAvatar()">
                    {{ 'players.avatarReset' | translate }}
                  </button>
                }

              </div>
            </div>
          }
          @if (profileSettingsMode === 'profile') {
            <div class="profile-settings-panel">
              <div class="card">
                <div class="card-body px-3 py-3">
                  <div class="form-group">
                    <label for="name" class="mb-0">
                      {{ 'common.name' | translate }}
                      <span class="form-label-info" tabindex="0" role="button" [attr.data-tooltip]="'players.visibleManager' | translate" [attr.aria-label]="'players.visibleManager' | translate">
                        <i [class]="'common.info' | nogoshIcon" aria-hidden="true"></i>
                      </span>
                    </label>
                    <input type="text" class="form-control" id="name" [placeholder]="'players.namePlaceholder' | translate" required [(ngModel)]="player.name" name="name">
                  </div>
                  <div class="form-group mb-0">
                    <label for="nickname" class="mb-0">
                      {{ 'common.nickname' | translate }}
                      <span class="form-label-info" tabindex="0" role="button" [attr.data-tooltip]="'players.visibleTeammates' | translate" [attr.aria-label]="'players.visibleTeammates' | translate">
                        <i [class]="'common.info' | nogoshIcon" aria-hidden="true"></i>
                      </span>
                    </label>
                    <input type="text" class="form-control" id="nickname" [placeholder]="'players.nicknamePlaceholder' | translate" required [(ngModel)]="player.nickName" name="nickName" #name="ngModel">
                  </div>
                </div>
              </div>
              <div appActionBar class="profile-settings-actions">
                <button type="button" class="btn btn-secondary btn-sm px-3" [disabled]="loading" (click)="closeProfileSettingsScreen()">{{ 'common.cancel' | translate }}</button>
                <button appSaveAction [saved]="profileSaved" [saving]="loading" type="submit" class="btn btn-primary btn-sm px-3" [disabled]="!playerForm.form.valid || loading || !hasProfileChanges()">{{ 'common.save' | translate }}</button>
              </div>
            </div>
          }
          @if (profileSettingsMode === 'contact') {
            <div class="profile-settings-panel">
              <div class="card">
                <div class="card-body px-3 py-3">
                  @if (shouldShowEmailVerificationReminder()) {
                    <div class="alert alert-warning" role="alert">
                      <p class="mb-2">{{ 'notifications.emailVerificationDescription' | translate }}</p>
                      <button type="button" class="btn btn-primary btn-sm px-3" [disabled]="emailVerificationLoading" (click)="sendVerificationEmail()">
                        @if (emailVerificationLoading) {
                          <app-delayed-indicator></app-delayed-indicator>
                        }
                        {{ 'notifications.sendVerificationEmail' | translate }}
                      </button>
                      @if (emailVerificationMessage) {
                        <p class="alert alert-success py-2 mt-3 mb-0" role="alert">{{emailVerificationMessage}}</p>
                      }
                      @if (emailVerificationError) {
                        <p class="alert alert-danger py-2 mt-3 mb-0" role="alert">{{emailVerificationError}}</p>
                      }
                    </div>
                  }
                  <div class="form-group">
                    <label for="email" class="mb-0">
                      {{ 'players.notificationEmail' | translate }}
                      <span class="form-label-info" tabindex="0" role="button" [attr.data-tooltip]="'players.visibleManager' | translate" [attr.aria-label]="'players.visibleManager' | translate">
                        <i [class]="'common.info' | nogoshIcon" aria-hidden="true"></i>
                      </span>
                    </label>
                    <input type="text" class="form-control" id="email" [placeholder]="'players.emailPlaceholder' | translate" [(ngModel)]="player.email" name="email">
                  </div>
                  <div class="form-group mb-0">
                    <label for="phone" class="mb-0">
                      {{ 'common.phone' | translate }}
                      <span class="form-label-info" tabindex="0" role="button" [attr.data-tooltip]="'players.visibleManager' | translate" [attr.aria-label]="'players.visibleManager' | translate">
                        <i [class]="'common.info' | nogoshIcon" aria-hidden="true"></i>
                      </span>
                    </label>
                    <input type="tel" class="form-control" id="phone" [placeholder]="'players.phonePlaceholder' | translate" [(ngModel)]="player.phoneNumber" name="phoneNumber">
                  </div>
                </div>
              </div>
              <div appActionBar class="profile-settings-actions">
                <button type="button" class="btn btn-secondary btn-sm px-3" [disabled]="loading" (click)="closeProfileSettingsScreen()">{{ 'common.cancel' | translate }}</button>
                <button appSaveAction [saved]="profileSaved" [saving]="loading" type="submit" class="btn btn-primary btn-sm px-3" [disabled]="!playerForm.form.valid || loading || !hasProfileChanges()">{{ 'common.save' | translate }}</button>
              </div>
            </div>
          }
          @if (profileSettingsMode === 'location') {
            <div class="profile-settings-panel">
              <div class="card">
                <div class="card-body px-3 py-3">
                  <div class="form-group">
                    <label for="city" class="mb-0">{{ 'common.city' | translate }}</label>
                    <div class="profile-location-autocomplete">
                      <input [ngModel]="player.city"
                        (ngModelChange)="onProfileCityInput($event)"
                        (focus)="showProfileCitySuggestions()"
                        (blur)="closeProfileLocationSuggestionsLater()"
                        [placeholder]="'players.cityPlaceholder' | translate"
                        name="city"
                        class="form-control"
                        [class.is-invalid]="hasProfileCity() && !isProfileCityValidForSave()"
                        id="city"
                        autocomplete="off"
                        type="search" />
                      @if (profileCityDropdownOpen) {
                        <div class="profile-location-suggestions" role="listbox">
                          @for (city of profileCitySuggestions; track city) {
                            <button type="button" class="profile-location-suggestion" role="option" (mousedown)="$event.preventDefault()" (click)="selectProfileCity(city)">
                              {{ city }}
                            </button>
                          }
                        </div>
                      }
                    </div>
                    @if (!player.city) {
                      <small class="form-text text-muted">{{ 'players.cityDiscoveryHint' | translate }}</small>
                    }
                    @if (hasProfileCity() && !isProfileCityValidForSave()) {
                      <small class="form-text text-danger">{{ 'players.citySelectionRequired' | translate }}</small>
                    }
                  </div>
                  <div class="form-group mb-0">
                    <label for="address" class="mb-0">
                      {{ 'common.address' | translate }}
                      <span class="form-label-info" tabindex="0" role="button" [attr.data-tooltip]="'players.optionalField' | translate" [attr.aria-label]="'players.optionalField' | translate">
                        <i [class]="'common.info' | nogoshIcon" aria-hidden="true"></i>
                      </span>
                    </label>
                    <div class="profile-location-autocomplete">
                      <input [ngModel]="player.address"
                        (ngModelChange)="onProfileAddressInput($event)"
                        (focus)="showProfileAddressSuggestions()"
                        (blur)="closeProfileLocationSuggestionsLater()"
                        [placeholder]="'players.addressPlaceholder' | translate"
                        name="address"
                        class="form-control"
                        [class.is-invalid]="hasProfileAddress() && !isProfileAddressValidForSave()"
                        id="address"
                        [disabled]="!hasSelectedProfileCity()"
                        autocomplete="off"
                        type="search" />
                      @if (profileAddressDropdownOpen) {
                        <div class="profile-location-suggestions" role="listbox">
                          @for (address of profileAddressSuggestions; track address) {
                            <button type="button" class="profile-location-suggestion" role="option" (mousedown)="$event.preventDefault()" (click)="selectProfileAddress(address)">
                              {{ address }}
                            </button>
                          }
                        </div>
                      }
                    </div>
                    @if (hasProfileAddress() && !isProfileAddressValidForSave()) {
                      <small class="form-text text-danger">{{ 'players.addressSelectionRequired' | translate }}</small>
                    }
                  </div>
                  @if (canMigrateSocialLoginToPassword()) {
                    <hr class="my-3">
                    <section aria-labelledby="loginIdentityMigrationTitle" data-testid="login-identity-migration">
                      <h6 id="loginIdentityMigrationTitle">{{ 'loginIdentityMigration.title' | translate }}</h6>
                      <p class="text-muted mb-3">{{ 'loginIdentityMigration.description' | translate }}</p>
                      <button type="button" class="btn btn-outline-primary btn-block" (click)="openLoginIdentityMigrationDialog()">
                        {{ 'loginIdentityMigration.action' | translate }}
                      </button>
                    </section>
                  }
                </div>
              </div>
              <div appActionBar class="profile-settings-actions">
                <button type="button" class="btn btn-secondary btn-sm px-3" [disabled]="loading" (click)="closeProfileSettingsScreen()">{{ 'common.cancel' | translate }}</button>
                <button type="button" class="btn btn-outline-secondary btn-sm px-3" [disabled]="loading || !player.city" (click)="clearProfileLocation()">{{ 'common.clear' | translate }}</button>
                <button appSaveAction [saved]="profileSaved" [saving]="loading" type="submit" class="btn btn-primary btn-sm px-3" [disabled]="!playerForm.form.valid || loading || !hasProfileChanges() || !isProfileLocationValidForSave()">{{ 'common.save' | translate }}</button>
              </div>
            </div>
          }
          @if (profileSettingsMode === 'notifications') {
            <div class="profile-settings-panel">
              <div class="card">
                <div class="card-body px-3 py-3">
                  <div class="mb-3 profile-discovery-setting">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input cursor-pointer" [checked]="player.active" name="activeCheckbox" [(ngModel)]="player.active" id="p_active" (change)="activePlayingChanged()">
                      <label class="custom-control-label cursor-pointer" for="p_active">{{ 'players.activePlayingLabel' | translate }}</label>
                    </div>
                    <p class="profile-discovery-help mb-0">{{ 'players.activePlayingHint' | translate }}</p>
                  </div>
                  <div class="mb-3 profile-discovery-setting" [class.is-disabled]="!player.active">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input cursor-pointer" [checked]="player.openProfile" name="openProfileCheckbox" [(ngModel)]="player.openProfile" id="p_open_invites" (change)="openProfileChanged()" [disabled]="!player.active">
                      <label class="custom-control-label cursor-pointer" for="p_open_invites">{{ 'players.openProfileLabel' | translate }}</label>
                    </div>
                    <p class="profile-discovery-help mb-0">{{ 'players.openProfileHint' | translate }}</p>
                  </div>
                  <div class="mb-3 profile-discovery-setting" [class.is-disabled]="!player.active">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input cursor-pointer" [checked]="player.allowTeammatesSOS" name="allowTeammatesSOSCheckbox" [(ngModel)]="player.allowTeammatesSOS" id="p_allowTeammatesSOS" [disabled]="!player.active">
                      <label class="custom-control-label cursor-pointer" for="p_allowTeammatesSOS">{{ 'players.sendTeammateSos' | translate }}</label>
                    </div>
                    <p class="profile-discovery-help mb-0">{{ 'players.sendTeammateSosHint' | translate }}</p>
                  </div>
                  <div class="mb-0 profile-discovery-setting" [class.is-disabled]="!player.active || !player.openProfile">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input cursor-pointer" [checked]="player.allowCitySOS" name="allowCitySOSCheckbox" [(ngModel)]="player.allowCitySOS" id="p_allowCitySOS" [disabled]="!player.active || !player.openProfile">
                      <label class="custom-control-label cursor-pointer" for="p_allowCitySOS">{{ 'players.sendCitySos' | translate }}</label>
                    </div>
                    <p class="profile-discovery-help mb-0">{{ 'players.sendCitySosHint' | translate }}</p>
                  </div>
                </div>
              </div>
              <div appActionBar class="profile-settings-actions">
                <button type="button" class="btn btn-secondary btn-sm px-3" [disabled]="loading" (click)="closeProfileSettingsScreen()">{{ 'common.cancel' | translate }}</button>
                <button appSaveAction [saved]="profileSaved" [saving]="loading" type="submit" class="btn btn-primary btn-sm px-3" [disabled]="!playerForm.form.valid || loading || !hasProfileChanges()">{{ 'common.save' | translate }}</button>
              </div>
            </div>
          }
          @if (profileSettingsMode === 'language') {
            <div class="profile-settings-panel"><div class="card"><div class="card-body">
                  <section class="form-group" [attr.aria-label]="'settings.language.label' | translate">
                    <label for="preferredLanguage" class="mb-0">{{ 'settings.language.label' | translate }}</label>
                    <select id="preferredLanguage" name="preferredLanguage" class="form-control" [(ngModel)]="selectedLanguage" [disabled]="loading">
                      <option value="en">{{ 'languages.en' | translate }}</option>
                      <option value="hr">{{ 'languages.hr' | translate }}</option>
                    </select>
                  </section>
            </div></div><div appActionBar class="profile-settings-actions">
              <button type="button" class="btn btn-secondary" [disabled]="loading" (click)="closeProfileSettingsScreen()">{{ 'common.cancel' | translate }}</button>
              <button appSaveAction [saved]="profileSaved" [saving]="loading" type="submit" class="btn btn-primary" [disabled]="loading || !hasProfileChanges()">{{ 'common.save' | translate }}</button>
            </div></div>
          }
          @if (profileSettingsMode === 'account') {
            <div class="profile-settings-panel">
              @if (footballerAuthEnabled && loginMethods) {
                <section class="card mb-3"><div class="card-body">
                  <h2 class="h5">{{ 'footballerAuth.methodsTitle' | translate }}</h2>
                  @if (loginMethodsError) { <p class="text-danger" role="alert">{{ loginMethodsError | translate }}</p> }
                  @for (method of loginMethods.providers; track method.provider) {
                    <div class="d-flex align-items-center justify-content-between py-2">
                      <div><strong>{{ method.provider === 'google' ? 'Google' : method.provider === 'apple' ? 'Apple' : 'Facebook' }}</strong>
                        @if (method.connected) { <span class="d-block text-success">{{ 'footballerAuth.connected' | translate }}</span> }
                      </div>
                      @if (method.connected) {
                        <button type="button" class="btn btn-outline-primary" [disabled]="loginMethodsBusy || !method.canUnlink"
                          (click)="confirmUnlinkProvider(method.provider)">{{ 'footballerAuth.unlinkAction' | translate }}</button>
                      } @else {
                        <button type="button" class="btn btn-outline-primary" [disabled]="loginMethodsBusy || !method.available"
                          (click)="linkProvider(method.provider)">{{ 'footballerAuth.linkAction' | translate }}</button>
                      }
                    </div>
                  }
                  <p class="small mt-2">{{ 'footballerAuth.lastMethod' | translate }}</p>
                  <div class="d-flex align-items-center justify-content-between py-2">
                    <div>{{ 'footballerAuth.password' | translate }}
                      @if (loginMethods.passwordReady) { <span class="d-block text-success">{{ 'footballerAuth.connected' | translate }}</span> }
                    </div>
                    <button type="button" class="btn btn-outline-primary" [disabled]="loginMethodsBusy" (click)="setAccountPassword()">{{ 'footballerAuth.requestTitle' | translate }}</button>
                  </div>
                </div></section>
              }
              <div class="card">
                <div class="card-body px-3 py-3">

                  <div class="form-group mb-0">
                    <label for="loginEmail" class="mb-0">{{ 'players.loginEmail' | translate }}</label>
                    <input type="text" class="form-control disabled" id="loginEmail" [(ngModel)]="player.loginEmail" name="loginEmail" disabled>
                    @if (isEmailVerified()) {
                      <p class="alert alert-success py-2 mt-2 mb-0" role="status">
                        {{ 'notifications.emailVerificationConfirmedShort' | translate }}
                      </p>
                    } @else if (shouldShowEmailVerificationReminder()) {
                      <button type="button" class="btn btn-outline-primary mt-2" (click)="openProfileSettingsMode('contact')">{{ 'notifications.emailVerificationTitle' | translate }}</button>
                    }
                  </div>
                </div>
              </div>
              <div appActionBar class="profile-settings-actions">
                <button type="button" class="btn btn-secondary btn-sm px-3" [disabled]="loading" (click)="closeProfileSettingsScreen()">{{ 'common.close' | translate }}</button>
              </div>
              <button type="button" class="btn btn-danger btn-block btn-lg mt-4" (click)="openDeleteProfileDialog()">{{ 'players.deleteProfile' | translate }}</button>
                <app-dialog [(visible)]="showDeleteDialog">
                  <div class="modal-header">
                    <h5 class="mb-0">{{ 'players.deleteTitle' | translate }}</h5>
                  </div>
                  <div class="modal-body">
                    <p>{{ 'players.deleteDescription' | translate }}</p>
                    @if (hasDeleteProfileBlockers()) {
                      <div class="alert alert-warning mb-3" role="alert">
                        <p class="mb-2">{{ 'players.deleteBlockedIntro' | translate }}</p>
                        @if (deleteProfileBlockers.managedEvents?.length) {
                          <p class="font-weight-bold mb-1">{{ 'players.deleteBlockedMatches' | translate }}</p>
                          <ul class="mb-2 pl-3">
                            @for (managedEvent of deleteProfileBlockers.managedEvents; track managedEvent.id) {
                              <li>{{ managedEvent.name }}</li>
                            }
                          </ul>
                        }
                        @if (deleteProfileBlockers.managedPlaySpaces?.length) {
                          <p class="font-weight-bold mb-1">{{ 'players.deleteBlockedLocations' | translate }}</p>
                          <ul class="mb-2 pl-3">
                            @for (managedPlaySpace of deleteProfileBlockers.managedPlaySpaces; track managedPlaySpace.id) {
                              <li>{{ managedPlaySpace.name }}</li>
                            }
                          </ul>
                        }
                        <p class="mb-0">{{ 'players.deleteForceDescription' | translate }}</p>
                      </div>
                    }
                    @if (deleteProfileError) {
                      <div class="alert alert-danger mb-0" role="alert">
                        {{ deleteProfileError }}
                      </div>
                    }
                  </div>
                  <div class="modal-footer justify-content-start">
                    <button type="button" class="btn btn-secondary btn-sm px-3" [disabled]="deleteProfileLoading" (click)="closeDeleteProfileDialog()">{{ 'players.deleteCancel' | translate }}</button>
                    @if (!hasDeleteProfileBlockers()) {
                      <button type="button" class="btn btn-primary text-white btn-sm px-3" [disabled]="deleteProfileLoading" (click)="deleteProfile()">
                        @if (deleteProfileLoading) {
                          <app-delayed-indicator></app-delayed-indicator>
                        }
                        {{ 'players.deleteConfirm' | translate }}
                      </button>
                    }
                    @if (hasDeleteProfileBlockers()) {
                      <button type="button" class="btn btn-danger btn-sm px-3" [disabled]="deleteProfileLoading" (click)="deleteProfile(true)">
                        @if (deleteProfileLoading) {
                          <app-delayed-indicator></app-delayed-indicator>
                        }
                        {{ 'players.deleteForceConfirm' | translate }}
                      </button>
                    }
                  </div>
                </app-dialog>
              <div class="profile-settings-privacy">
                <a href="https://www.footballer.zone/privacy.html">{{ 'players.privacy' | translate }}</a>
              </div>
              <app-dialog [(visible)]="showLoginIdentityMigrationDialog">
                <div class="modal-header">
                  <h5 class="mb-0">{{ 'loginIdentityMigration.confirmTitle' | translate }}</h5>
                </div>
                <div class="modal-body">
                  <p>{{ 'loginIdentityMigration.confirmDescription' | translate }}</p>
                  @if (loginIdentityMigrationError) {
                    <p class="alert alert-danger mb-0" role="alert">{{ 'loginIdentityMigration.error' | translate }}</p>
                  }
                </div>
                <div class="modal-footer justify-content-start">
                  <button type="button" class="btn btn-secondary btn-sm px-3" [disabled]="loginIdentityMigrationLoading" (click)="closeLoginIdentityMigrationDialog()">
                    {{ 'common.cancel' | translate }}
                  </button>
                  <button type="button" class="btn btn-primary btn-sm px-3" [disabled]="loginIdentityMigrationLoading" (click)="beginLoginIdentityMigration()">
                    @if (loginIdentityMigrationLoading) {
                      <app-delayed-indicator></app-delayed-indicator>
                    }
                    {{ 'loginIdentityMigration.confirmAction' | translate }}
                  </button>
                </div>
              </app-dialog>
            </div>
          }
        </section>
        </form>
      }
      <app-dialog [(visible)]="showAvatarPreview">
        <div class="modal-header"><h2 class="h5 mb-0">{{ player.nickName || player.name }}</h2></div>
        <div class="modal-body"><img [src]="player.avatar" [alt]="'accessibility.userProfileImage' | translate" class="profile-avatar-preview"></div>
        <div class="modal-footer"><button type="button" class="btn btn-secondary" (click)="showAvatarPreview = false">{{ 'common.close' | translate }}</button></div>
      </app-dialog>
    </app-screen-shell>
  }
